import moment from '@/moment-gp'
/* =============================================================================
DB:       Realtime DB
PATH:     /user/{uid}/calendar_items/*
PURPOSE:  Stores the user calendar
============================================================================= */

// TODO: Entfällt?

export default {
  create({ name }, data, BACKEND) {
    return  {
      createdAt:              moment.currentTimeServer(BACKEND),
      // createdBy:              userId,
      cachedName:             name,       // String
      done:                   false,      // Boolean
      gaveUp:                 false,      // Boolean
      timekeeper: {
        timerActive:              false,  // Boolean
        timerStartedAt:           null,   // Datetime
        timerStoppedAt:           null,   // Datetime
        timeAdded:                0,      // Number
        // timerGoalId: taskId
      },
      optStart:               data.optStart ? data.optStart.toBackend(BACKEND) : 0,        // Timestamp
      optEnd:                 data.optEnd ? data.optEnd.toBackend(BACKEND) : 0,            // Timestamp
      optAssignedTo:          null,       // UUID Person
      userStart:              data.userStart ? data.userStart.toBackend(BACKEND) : null,   // Time (Userdefined)
      userEnd:                data.userEnd ? data.userEnd.toBackend(BACKEND) : null,       // Time (Userdefined)
      userAssignedTo:         null,       // UUID Person (Userdefined)
      extGoogleCalendarUUID:  null,       // UUID
      // ALT/DELETE:
      projectId:              data.projectId || null,  // UUID project
      taskId:                 data.taskId || null,     // UUID task
      autoplanningRequired:   true,       // Boolean # Nach drag and drop auf true
      accepted:               false,      // Boolean
      // NEU:
      tscId:                  data.tscId || null,  // TODO: Warum?
      /* Why do we need a goalId, when we know it from the commitmentId.
         Because we might create a session manually and then assign it to
         a goal without assigning it to an commitment */
      goalId:                 data.goalId || null,
      commitmentId:           data.commitmentId || null,
      // DELME: sessionId:              data.sessionId || null, // event = session?
      // NEU 10.12.2018:
      seqItemId:              data.seqItemId || null,
      // seqRepetition:       data.sequenceRepetition || 1, // starts with 1, not 0
      // NEU 12.12.2018:
      originIsOptimizer:      data.originIsOptimizer || false,
      assignedTaskIds:        [] // List of taskIds
    };
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    cachedName: { validate_bolt_type: 'String' },
    done: { validate_bolt_type: 'Boolean' },
    gaveUp: { validate_bolt_type: 'Boolean' },
    timekeeper: {},
    optStart: {},
    optEnd: {},
    optAssignedTo: {},
    userStart: {},
    userEnd: {},
    userAssignedTo: {},
    extGoogleCalendarUUID: {},
    projectId: {},
    taskId: {},
    autoplanningRequired: {},
    accepted: {},
    tscId: {},
    goalId: {},
    commitmentId: {},
    seqItemId: {},
    originIsOptimizer: {},
    assignedTaskIds: {},
  }
};
